<template>
    <div class="btn-group btn-group-toggle justify-content-around" data-toggle="buttons">
        <label class="btn" :class="inputValue === 'true' ? 'active btn-success' : 'btn-secondary'">
            <input type="radio" :name="name" value="true" v-model="inputValue" checked> <i class="fa fa-check"/>
        </label>
        <label class="btn" :class="inputValue === 'false' ? 'active btn-danger' : 'btn-secondary'">
            <input type="radio" :name="name" value="false" v-model="inputValue"> <i class="fa fa-times"/>
        </label>
    </div>
</template>

<script>
export default {
    name: "question-boolean",
    props: {
        name: {
            required: true
        },
        value: {
            required: false,
            default: null,
        }
    },
    data() {
        return {
            inputValue: null
        }
    },
    watch: {
        inputValue: function (newVal) {
            this.$emit('input', newVal);
        },
    },
    mounted() {
        this.inputValue = this.value
    }
}
</script>

<style scoped>

</style>
